import { selector } from "recoil";

import {
  calculateDateDifference,
  generateDatesArrayYMDString,
} from "../../helpers";
import { DateYMDString } from "../../models";
import { topCalendarDatesAtomFamily } from "../atoms";
import { timezoneSelector } from "./system-settings.selectors";

const courseEntity = "course" as const;

export const datesArrayCalendarCoursesSF = selector<DateYMDString[]>({
  key: "datesArrayCalendarCoursesSF",
  get: ({ get }) => {
    const calendarDates = get(topCalendarDatesAtomFamily(courseEntity));
    if (!calendarDates) {
      return [];
    }
    const timezone = get(timezoneSelector);
    return (
      generateDatesArrayYMDString(
        calendarDates.date1,
        calendarDates.date2,
        timezone,
      ) ?? []
    );
  },
});

export const daysCountCalendarCoursesSF = selector<number>({
  key: "daysCountCalendarCoursesSF",
  get: ({ get }) => {
    const calendarDates = get(topCalendarDatesAtomFamily(courseEntity));
    if (!calendarDates) {
      return 0;
    }
    return calculateDateDifference(calendarDates.date1, calendarDates.date2);
  },
});
